<template>
  <span class="n-icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" :fill="fill">
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M5 9h14c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm0 4h8c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1z"
      /></svg
  ></span>
</template>

<script lang="ts" setup>
defineProps({
  fill: {
    type: String,
    default: 'currentColor',
  },
});

defineOptions({
  name: 'n-short-text-icon',
});
</script>
